import { EntryWithPredictions } from '@staycool/contests-types/entry';
import { createStores } from './store/utils';
import { PredictionStatus } from '@staycool/contests-types/prediction';

export const contestSelections = createStores({
    activeEntry: null as null | EntryWithPredictions,
    activeLegId: undefined as string | undefined,
    entries: [] as EntryWithPredictions[],
    selections: {} as Record<string, { marketId: number; outcomeId: number; matchId: number; legId: string }[]>,
    initialSelections: {} as Record<
        string,
        { marketId: number; outcomeId: number; matchId: number; legId: string; status?: PredictionStatus }[]
    >,
});
